/* unplugin-vue-components disabled */import script from "./SharingSharer.vue?vue&type=script&setup=true&lang=js"
export * from "./SharingSharer.vue?vue&type=script&setup=true&lang=js"

import "./SharingSharer.vue?vue&type=style&index=0&id=70aaf307&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70aaf307"]])

export default __exports__